const dateConfig = {
  date_display: 'M/D/YYYY',
  date_format: 'YYYY-MM-DD',
  timestamp: 'MMM D - h:mm a',
  currentDate: new Date().toISOString().substr(0, 10)
}

export default dateConfig
